<template>
  <div>
    <v-card>
      <v-tabs
        v-model="tab"
        align-with-title
        background-color="amber"
        grow
      >
        <v-tabs-slider color="blue"></v-tabs-slider>

        <v-tab @click="refreshTab('table')">Update Scheduler</v-tab>
        <v-tab @click="refreshTab('daily')">Daily Activity</v-tab>
        <v-tab @click="refreshTab('hourly')">Hourly Activity</v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <UpdateSchedulerTable ref="table"/>
        </v-tab-item>
        <v-tab-item>
          <DailyActivity ref="daily"/>
        </v-tab-item>
        <v-tab-item>
          <HourlyActivity ref="hourly"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import UpdateSchedulerTable from './UpdateSchedulerTable.vue';
import DailyActivity from './DailyActivity.vue';
import HourlyActivity from './HourlyActivity.vue';

export default {
  components: {
    UpdateSchedulerTable,
    DailyActivity,
    HourlyActivity,
  },

  data() {
    return {
      tab: 0,
    };
  },

  methods: {
    refreshTab(tab) {
      if (this.$refs[tab]) {
        // this.$refs[tab].getData();
      }
    },
  },
};
</script>

<style scoped>
</style>
